import React, { ReactNode } from "react";
import styles from "./round-border-component-container.module.scss";

interface RoundBorderComponentContainerPropTypes {
  children: ReactNode;
}

const cssClassName = "round-border-component-container";

export const RoundBorderComponentContainer = ({
  children,
}: RoundBorderComponentContainerPropTypes) => {
  return (
    <div className={styles[cssClassName]}>
      <div className={styles[`${cssClassName}__outer-border-container`]}>
        <div className={styles[`${cssClassName}__gradient-border`]}>
          {children}
        </div>
      </div>
    </div>
  );
};
